import axios from "axios";

export const exportRequest = async (options, state, name) => {
  let requestForBlob = async () => {
    let accessToken = localStorage.getItem("accToken");
    let refreshToken = localStorage.getItem("refreshToken");
    let selectedTenant = JSON.parse(localStorage.getItem("selectedTenant"));

    let source = axios.CancelToken.source();
    let config = {
      url: window.location.host + options.url,
      ...options,
      withCredentials: true,
      headers: {
        cancelToken: source.token,
        Authorization: accessToken,
        "X-Tenant-ID": selectedTenant.domain,

        Accept: "application/vnd.handson.rfid.v5+json",
        "Content-Type": options?.params?.content
          ? options.params.content
          : "application/json",
      },
    };
    const requestInterceptor = (config) => {
      if (accessToken) {
        config.headers.Authorization = localStorage.getItem("accToken");
      }
      return config;
    };
    axios.interceptors.request.use(requestInterceptor);

    let response;

    try {
      response = await axios(config);
    } catch (err) {
      if (axios.isCancel(err)) {
        console.log("Request canceled:", err.message);
        return;
      }
      // Checking if response status is 401
      if (err.response && err.response.status === 401) {
        try {
          const refreshConfig = {
            url: "/api/token/refresh",
            method: "POST",
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
              "X-Tenant-ID": selectedTenant.domain,
              Authorization: refreshToken,
            },
          };

          const refreshResponse = await axios(refreshConfig);

          let newAccToken = refreshResponse.headers.authorization;

          localStorage.setItem(
            "accToken",
            refreshResponse.headers.authorization
          );
          accessToken = newAccToken;

          localStorage.setItem(
            "refreshToken",
            refreshResponse.headers["x-auth-refresh-token"]
          );
          config.headers.Authorization = accessToken;

          response = await axios(config);
        } catch (refreshErr) {
          console.log("Error refreshing token:", refreshErr.message);
          localStorage.clear();

          location.reload();

          return;
        }
      } else {
        console.log("Error:", err.message);
        return;
      }
    }
    return response;
  };
  let response = await requestForBlob();
  console.log(response);
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute(
    "download",
    `${name}` + `-${new Date().toISOString().slice(0, 30)}.csv`
  );
  document.body.appendChild(link);
  link.click();
  state(false);
};
